<template>
  <div class="container">
    <div class="col-12 col-md-6">
      <transition name="fade"
                  appear>
        <div
          v-if="!hasAuth"
          class="container">
          <div class="d-flex justify-content-center flex-column align-items-center">
            <div>
              <h4 class="title-box">
                Integrações ON-RCPN
              </h4>
              <div class="info-box">
                <div class="container mt-2 p-4">
                  <p class="text-box">
                    Você autoriza o <b>tratamento dos seus dados pessoais</b> para fins exclusivos de atendimento à demanda inserida no formulário de Integrações ON-RCPN?
                  </p>
                </div>
                <div class="footer-box">
                  <b-button
                    class="button-default__cancel ml-3"
                    @click="()=> handleAuth(false)">
                    Não
                  </b-button>
                  <b-button
                    class="btn-primary mr-3"
                    variant="primary"
                    @click="()=> handleAuth(true)">
                    <b>Autorizo</b>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Integracoes",
    data () {
      return {
        hasAuth: false
      }
    },
    methods: {
      handleAuth (value) {
        if (value === true) {
          this.hasAuth = !this.hasAuth
          this.$router.push({ name: 'onrcpn-integracoes-formulario' })
        } else {
          this.$router.push('/')
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
@import "../../../../scss/_utilities/variables";
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.info-box{
    width: 510px;
    height: 201px;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media #{$xs}{
        width: 100%;
        margin-bottom: 40px;
        height: auto !important;
    }
}

.title-box{
    font-size: 20px;
}

.text-box{
    color: #707070;
    font-weight: normal;
}

.footer-box{
    background-color: #F9F9F9;
    padding: 10px;
    border-radius: 0px 0px 4px 4px;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
</style>
